export enum FilterName {
  FreeText = 'freeText',
  CustomerId = 'customerId',
  ProductId = 'productId',
  LicenseStateName = 'licenseState',
  ExpirationDate = 'expirationDate',
}

export enum LicenseState {
  Queued = 'Queued',
  Completed = 'Completed',
  RenewalApplication = 'RenewalApplication',
  RenewalApproved = 'RenewalApproved',
  RenewalV2CDownloaded = 'RenewalV2CDownloaded',
  RenewalRejected = 'RenewalRejected',
  Expired = 'Expired',
}

export enum LicenseFile {
  C2V = 'c2v',
  V2C = 'v2c',
}
